/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Slot_HeroInputs */

const cs_builder_slot_hero = /** @type {(inputs: Builder_Slot_HeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní foto`)
};

const en_builder_slot_hero = /** @type {(inputs: Builder_Slot_HeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hero photo`)
};

/**
* | output |
* | --- |
* | "Hero photo" |
*
* @param {Builder_Slot_HeroInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_slot_hero = /** @type {((inputs?: Builder_Slot_HeroInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Slot_HeroInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_slot_hero(inputs)
	return cs_builder_slot_hero(inputs)
});